namespace TabAurous.Retail {
    export namespace OrderMagentoImportService {
        export const baseUrl = 'Retail/OrderMagentoImport';

        export declare function List(request: ReportFiltersRequest, onSuccess?: (response: Serenity.ListResponse<POSOrderRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            List = "Retail/OrderMagentoImport/List"
        }

        [
            'List'
        ].forEach(x => {
            (<any>OrderMagentoImportService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
